<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장하기 버튼 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveCats">저장하기</button>
        </div>
        <div class="box">
          <admin-box-item title="FAQ 카테고리 목록"
                          :useTab="false"
                          subtitle="*카테고리를 삭제하면 복구가 불가능합니다.">
            <div style="overflow-y: auto">
              <div style="height: 450px">
                <li v-for="(cat, idx) in categories" v-bind:key="'cat'+idx">
                  <div class="lp-cat-item">
                    <input class="input"
                           placeholder="새 카테고리"
                           :value="cat.label"
                           @input="e => cat.label = e.target.value">
                    <div style="flex:1"></div>
                    <button class="button is-danger" @click="delCategory(categories, idx)">삭제</button>
                  </div>
                </li>
              </div>
            </div>
            <div class="btn-add-category" @click="addCategory">+ 새 카테고리 추가</div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from "../../module/common/InputImg";
  import LpDropdown from "../../module/common/LpDropdown";
  import LpInputText from "../../module/common/LpInputText";
  export default {

    components: {
      LpInputText,
      LpDropdown,
      InputImg,
      draggable,
      BreadCrumb
    },
    created() {
      this.getCats();
    },
    data() {
      return {
        catgroup: [],
        categories: [],
      }
    },
    methods: {
      //카테고리 목록 가져오기
      getCats() {
        this.$axios.get(this.getUrl('board/faq/category')).then(res=>{
          this.categories = res.data;
        })
      },
      addCategory() {
        this.categories.push({
          value: 0,
          label: '',
        })
      },
      delCategory(cat, idx) {
        if(cat[idx].value===0) {
          removeIndex(cat,idx);
        }
        else {
          this.$axios.delete(this.getUrl('board/faq/category/'+cat[idx].value))
            .then(res => {
              if(res.status===200) {
                this.toast('카테고리가 삭제되었습니다.');
                removeIndex(cat,idx);
              }
            });
        }
      },
      saveCats() {
        this.$axios.post(this.getUrl('board/faq/category'),{'categories': this.categories})
          .then(res => {
            this.$root.$emit('toast','저장되었습니다.');
          })
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  //@import '~assets/css/lp_main'
  li
    list-style-type none
    list-style none

  .div-category
    margin-right 20px
    width 500px

  .box-category
    box-sizing border-box
    padding 20px
    background-color white
    overflow-y auto
    max-height 500px

  .lp-row-title
    color #064160
    font-size 1.1rem
    border-bottom 1px solid #555
    padding-bottom 8px
    margin-bottom 20px

  .lp-total-title
    color #064160
    font-size 0.9rem
    margin auto 0

  .ghost
    opacity .5
    background-color #c8ebfb

  .dragArea
    padding-left 20px
    min-height 10px

  .div-count
    border-radius 30px
    background-color #555
    color white
    font-size 0.7rem
    text-align center
    margin-left 8px
    width 18px
    height 18px
    line-height 18px

  .lp-cat-item-total
    box-sizing border-box
    display flex
    justify-content space-between
    margin-top 20px
    margin-bottom 8px
    padding 12px 8px
    width 100%
    background-color #eceeef
    color #555
    font-size 0.9rem

  .lp-cat-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px
  .lp-cat-item div
    margin auto 0
    margin-right 8px
  .lp-cat-item div:last-child
    margin-right 0

  .btn-add-category
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  label
    color #064160
    font-size 0.8rem

  .lp-content input
    margin-top 4px
    margin-left 8px
    border 0
    padding 4px 12px
    background #f2f6f8
    font-size 0.9rem

  .lp-cat-btn
    color #787878
    border 1px solid #787878
    margin-top 16px
    margin-right 8px
    border-radius 3px
    padding 4px 20px
    font-size 0.9rem
    text-align center
    display inline-block

  .lp-cat-btn.select
    border 1px solid $primary
    color $primary

  .btn-update
    margin-bottom 0
</style>
